<!-- Redesigned Compact Layout — Transfer Pipeline Card -->
<div *ngIf="compact" class="pipeline-card">
  <div class="pipeline-title">TRANSFER PIPELINE</div>
  <div class="pipeline-row">
    <!-- Source node -->
    <div class="pipeline-node pipeline-node--source">
      <div class="pipeline-node__icon-wrap pipeline-node__icon-wrap--source">
        <mat-icon class="pipeline-node__icon">business</mat-icon>
      </div>
      <div class="pipeline-node__label pipeline-node__label--source">SOURCE</div>
      <div class="pipeline-node__name">{{ origin }}</div>
    </div>

    <!-- Animated chevrons -->
    <div class="pipeline-arrows" [class.pipeline-arrows--reverse]="isReverse">
      <span class="pipeline-arrow pipeline-arrow--1"></span>
      <span class="pipeline-arrow pipeline-arrow--2"></span>
      <span class="pipeline-arrow pipeline-arrow--3"></span>
      <span class="pipeline-arrow pipeline-arrow--4"></span>
      <span class="pipeline-arrow pipeline-arrow--5"></span>
    </div>

    <!-- Target node -->
    <div class="pipeline-node pipeline-node--target">
      <div class="pipeline-node__icon-wrap pipeline-node__icon-wrap--target">
        <mat-icon class="pipeline-node__icon">business</mat-icon>
      </div>
      <div class="pipeline-node__label pipeline-node__label--target">TARGET</div>
      <div class="pipeline-node__name">{{ target }}</div>
    </div>
  </div>

  <button *ngIf="showChangeTarget"
          class="pipeline-change-target-btn"
          mat-button
          (click)="changeTarget.emit()">
    <mat-icon>edit</mat-icon>
    Change the target
  </button>
</div>

<!-- Standard Horizontal Layout -->
<div *ngIf="!compact" class="facility-summary">
  <div class="facility-box facility-box--origin">
    <div class="facility-box__label">SOURCE FACILITY</div>
    <div class="facility-box__name">{{ origin }}</div>
    <div *ngIf="originLocation" class="facility-box__location">{{ originLocation }}</div>
  </div>

  <div class="arrow-animation" [class.arrow-animation--reverse]="isReverse">
    <div class="arrow">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="arrow-text">TRANSFERRING</div>
  </div>

  <div class="facility-box facility-box--target">
    <div class="facility-box__label">TARGET FACILITY</div>
    <div class="facility-box__name">{{ target }}</div>
    <div *ngIf="targetLocation" class="facility-box__location">{{ targetLocation }}</div>
  </div>
</div>
